import { Children, cloneElement, useContext } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

import { features } from '@h2/components/media'
import { container } from '@h2/components/mixins'
import { Globals } from '@h2/globals'
import { WHITE, GRAYSHADOW } from '@h2/components/colors'

import { Content } from './content'
import { Highlight } from './highlight'
import { Detour } from './detour'

const getTemplateAreas = ({ leftSided, hasDetour, useDetour }) => {
  if (hasDetour && useDetour) {
    if (leftSided) {
      return `
        "cnt hlt"
        "dtr hlt"
      `
    }

    return `
      "hlt cnt"
      "hlt dtr"
    `
  }

  if (leftSided) {
    return '"cnt hlt"'
  }

  return '"hlt cnt"'
}
const getMobileTemplateAreas = ({ hasDetour }) => {
  if (hasDetour) {
    return `
      "hlt"
      "cnt"
      "dtr"
    `
  }

  return `
    "hlt"
    "cnt"
  `
}
const Grid = styled.div`
  background: white;
  display: grid;
  grid-template-areas: ${getMobileTemplateAreas};
  background: ${WHITE} 0% 0% no-repeat padding-box;

  ${({isNavianceUser}) => isNavianceUser && css`
    & div:first-child {
      justify-content: center;
    }
  `}
  box-shadow: ${({ isNavianceUser }) =>
    isNavianceUser ? `0px 3px 6px ${GRAYSHADOW}` : 'none'};

  @media (${features.minWidth.laptop}) {
    ${container};
    margin: auto;
    min-height: 470px;
    grid-auto-rows: auto 45px;
    grid-template-columns: ${({ leftSided }) => (leftSided ? '65% 35%' : '35% 65%')};
    grid-template-areas: ${getTemplateAreas};
    ${({ isNavianceUser }) => isNavianceUser && `padding: 0`}
  }
`
const Card = ({ children, inDialog = false, leftSided = false, useDetour = false }) => {
  const applied = Children.toArray(children)
    .map(child => child.type.slotName)
    .filter(Boolean)
  const hasDetour = applied.includes(Detour.slotName)
  const { isNavianceUser } = useContext(Globals)

  return (
    <Grid
      isNavianceUser={isNavianceUser}
      inDialog={inDialog}
      leftSided={leftSided}
      hasDetour={hasDetour}
      useDetour={useDetour}>
      {Children.map(children, child => {
        if (child?.type.slotName === Detour.slotName) {
          return cloneElement(child, { useDetour })
        }

        return child
      })}
    </Grid>
  )
}

Card.propTypes = {
  /* Whether the Card should support a grid area for a detour (detour is generally only used for mobile) */
  useDetour: PropTypes.bool,
  /* Whether the Cards are rendered inside a modal */
  inDialog: PropTypes.bool,
  /* Whether the content area is on the left, instead of right */
  leftSided: PropTypes.bool
}

Card.Content = Content
Card.Highlight = Highlight
Card.Detour = Detour

export { Card }
